import { createConfig } from "@gluestack-style/react";
import { config as defaultConfig } from "@gluestack-ui/config";
const config = createConfig({
	...defaultConfig,
	tokens: {
		...defaultConfig.tokens,
		breakpoints: {
			base: 0,
			md: 992,
			lg: 1280,
			xl: 1568,
		},
		mediaQueries: {
			base: "@media (min-width: 0px)",
			md: "@media (min-width: 1024px)",
			lg: "@media (min-width: 1280px)",
			xl: "@media (min-width: 1920px)",
		},
		fontWeights: {
			...defaultConfig.tokens.fontWeights,
			bold: "Roboto_700Bold",
		},
		colors: {
			textLight700: "#173648",
			textLight400: "#173648",
			textLight500: "#173648",
			textLight900: "#173648",
			primary: "#1A428A",
			primarylight: "#2B6FBB",
			primarylightblue: "#42CBCF",
			primarydark: "#1B3377",
			secondary: "#A0BD1E",
			secondarylight: "#D1DD96",
			secondarydark: "#799A05",
			primarydarkgreen: "#41693D",
			darkgreenxlight: "#F1F8ED",
			darkgreenlight: "#AED797",
			darkgreenbright: "#5C8C4F",
			darkgreendark: "#32562F",
			darkgreenxdark: "#254523",
			darkgreen2xdark: "#1C3B1A",
			darkgreendisabled: "#EBF5E5",
			primarymidgreen: "#799A05",
			midgreenxlight: "#EFF3E1",
			midgreenlight: "#D1DD96",
			midgreenbright: "#A0BD1E",
			midgreendark: "#5C7E03",
			midgreenxdark: "#496C01",
			midgreen2xdark: "#385E00",
			midgreendisabled: "#EBEFD9",
			primarydarkblue: "#1A428A",
			darkbluexlight: "#E3F1FA",
			darkbluelight: "#6AAEE5",
			darkbluebright: "#2B6FBB",
			darkbluedark: "#1B3377",
			darkbluexdark: "#132868",
			darkblue2xdark: "#081D5A",
			darkbluedisabled: "#DCEDF9",
			secondarymain: "#4DCC92",
			darkteal: "#173648",
			darktealxlight: "#E0F1FF",
			darkteallight: "#6C94AF",
			darktealbright: "#375E76",
			darktealdark: "#112938",
			darktealxdark: "#0A1B26",
			darkteal2xdark: "#010202",
			darktealdisabled: "#D3DFE7",
			secondarymidteal: "#006985",
			midtealxlight: "#DCF1F9",
			midteallight: "#86BDD6",
			midtealbright: "#428BA9",
			midtealdark: "#005672",
			midtealxdark: "#00425A",
			midteal2xdark: "#002D42",
			midtealdisabled: "#D3EDF7",
			secondarylightteal: "#00A2A5",
			lighttealxlight: "#DFF6F6",
			lightteallight: "#AFE9E9",
			lighttealbright: "#42CBCF",
			lighttealdark: "#009093",
			lighttealxdark: "#007574",
			lightteal2xdark: "#006563",
			lighttealdisabled: "#D7F3F3",
			greenxlight: "#E2F6EC",
			greenlight: "#C6EDC4",
			greenbright: "#9FE19E",
			greendark: "#00C17C",
			greenxdark: "#00B465",
			green2xdark: "#00A55B",
			greendisabled: "#CAF0DE",
			successmain: "#1EAB4E",
			successxlight: "#F5FFF9",
			successlight: "#D4FADF",
			successbright: "#00C652",
			successdark: "#008537",
			successxdark: "#006B2B",
			success2xdark: "#005E27",
			successdisabled: "#CAEAD7",
			errormain: "#E71D29",
			errorxlight: "#FFF3F5",
			errorlight: "#FFDCE0",
			errorbright: "#F92835",
			errordark: "#C91520",
			errorxdark: "#9C121A",
			error2xdark: "#730A10",
			errordisabled: "#F1DBDC",
			warningmain: "#FFC226",
			warningxlight: "#FEFCE6",
			warninglight: "#FCF299",
			warningbright: "#F7D22C",
			warningdark: "#FFAC17",
			warningxdark: "#FE9B03",
			warning2xdark: "#FE8A04",
			warningdisabled: "#FBF2DB",
			datavizspendplus: "#42CBCF",
			datavizspendminus: "#F21766",
			datavizbudget: "#173648",
			datavizprevious: "#FFC226",
			datavizhighlightlight: "#DFF6F6",
			datavizhighlight: "#42CBCF",
			datavizhighlightdark: "#00A2A5",
			datavizindustry: "#2B6FBB",
			datavizdefault: "#CCCCCC",
			basicwhite: "#FFFFFF",
			basicblack: "#000000",
			neutral25: "#FAFAFA",
			neutral35: "#F7F7F7",
			neutral50: "#F5F5F5",
			neutral100: "#E6E6E6",
			neutral200: "#CCCCCC",
			neutral300: "#B3B3B3",
			neutral400: "#999999",
			neutral500: "#808080",
			neutral600: "#666666",
			neutral700: "#4D4D4D",
			neutral800: "#333333",
			neutral900: "#191919",
		},
		fontSizes: {
			...defaultConfig.tokens.fontSizes,
			herodesktop: 60,
			heromobile: 28,
			h1desktop: 44,
			h1mobile: 24,
			h2desktop: 36,
			h2mobile: 22,
			h3desktop: 28,
			h3mobile: 20,
			h4desktop: 20,
			h4mobile: 18,
			h5desktop: 18,
			h5mobile: 16,
			h6desktop: 16,
			h6mobile: 14,
			paragraphdesktop: 16,
			paragraphsmalldesktop: 14,
			linkdefaultdesktop: 16,
			linksmalldesktop: 14,
		},
		space: {
			px: "1px",
			containerWidthM: 1024,
			containerWidthL: 1184,
			containerWidthXL: 1728,
			"1/2": "50%",
			"1/4": "25%",
			"3/4": "75%",
			"1/3": "33.333333%",
			"2/3": "66.666667%",
			"1/6": "16.666667%",
			"5/6": "83.333333%",
			full: "100%",
			"0": 0,
			"0.5": 2,
			"1": 4,
			"1.5": 6,
			"2": 8,
			"2.5": 10,
			"3": 12,
			"3.5": 14,
			"4": 16,
			"4.5": 18,
			"5": 20,
		},
		borderWidths: {
			...defaultConfig.tokens.borderWidths,
			"20": 20,
			"50": 50,
		},
		opacity: {
			...defaultConfig.tokens.opacity,
		},
		fonts: {
			heading: "Roboto_400Regular",
			robotoBold: "Roboto_700Bold",
			body: "Roboto_400Regular",
			mono: "Roboto_400Regular",
		},
		globalStyle: {
			...defaultConfig.globalStyle,
			body: {
				backgroundColor: "$basicwhite",
			},
		},
	},
} as const);

export { config };

// Get the type of Config
type Config = typeof config;

declare module "@gluestack-style/react" {
	interface ICustomConfig extends Config {}
}
